// Form submissions stay on the V1 account (this factory is wired to the V1
// client in api/ltng/index.js). The forms were NOT re-created on the V2 account
// (task #5), so submitting to V2 would have no form definition to run. Original
// V1 path, restored from the pre-cutover code.
export default function (axios) {
  return {
    postFormSubmit(data, params = {}) {
      return axios.post('/modules/form-submit', data, params)
    },
  }
}
